import { mapGetters, mapActions } from 'vuex';
import mvtChart from '@/common/components/mvtchart/mvt-chart.vue';
import format from '@/common/utilities/format';
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function getMonth(index) {
    const tmpDate = new Date();
    tmpDate.setMonth(tmpDate.getMonth() + index);
    const month = tmpDate.getMonth() + 1;
    const year = tmpDate.getFullYear();
    return `${months[month - 1]} ${year}`;
}
export default {
    name: 'dppPriceTrend',
    inject: ['$eventBus'],
    components: {
        mvtChart,
    },
    props: {
        dpp: {
            type: Object,
            default: () => {
                return {};
            },
        },
        isMarket5YLoaded: {
            type: Boolean,
            default: false,
        },
        showDescription: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            forecastPrice: 0,
            forecastPriceRate: 0,
            forecastLabel: '',
            forecastPriceIncrease: true,
            lastMonthPrice: 0,
        };
    },
    watch: {
        forecastPrice(val) {
            if (val) {
                this.updateForecast({
                    price: this.forecastPrice,
                    rate: this.forecastPriceRate,
                    label: this.forecastLabel,
                    lastMonthPrice: this.lastMonthPrice,
                });
            } else {
                return null;
            }
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['getEstimateInfo']),
        getMarket5Y() {
            return this.dpp.market5Y;
        },
        priceHistoryData() {
            const datePriceMap = {};
            this.dpp.priceHistory &&
                this.dpp.priceHistory
                    .filter((item) => item.status === 'Sold')
                    .forEach((item) => {
                        const date = new Date(item.dateMobile);
                        const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`;
                        datePriceMap[monthYear] = item.priceDesktop.replace(/[$,]/g, '');
                    });
            return datePriceMap;
        },
        chartData() {
            const data = this.getMarket5Y;
            if (!data || !data.dailyCityStatisticsList || !data.dailyCityStatisticsList.length) {
                return null;
            }
            const currentIcon = new Image(0, 0);
            const estPrice = this.getEstimateInfo?.value || this.dpp.estPrice;
            if (data && estPrice) {
                let janStartIndex = data.dailyCityStatisticsList.findIndex((item) => item.monthYear.includes('/01'));
                if (janStartIndex === -1) {
                    janStartIndex = 0;
                }
                const maxItem = data.dailyCityStatisticsList;
                const date = new Date();
                const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`;
                let label = [],
                    dataset = [],
                    label1 = [monthYear],
                    dataset1 = [estPrice];
                for (let i = maxItem.length - 1; i >= janStartIndex; i--) {
                    const item = maxItem[i].allTypeMedianListPrice;
                    const item1 = maxItem[i - 1] ? maxItem[i - 1].allTypeMedianListPrice : item;
                    //------- trick code not matter what years date we are using, treat them as last 5 years
                    label.unshift(getMonth(i - maxItem.length));
                    //------- tip: the real data should be maxItem[i].monthYear;
                    if (!item1 || !item) {
                        dataset.unshift(dataset[0] || estPrice);
                    } else if (dataset.length) {
                        dataset.unshift(Math.floor((item1 / item) * dataset[0]));
                    } else {
                        dataset.unshift(Math.floor((item1 / item) * estPrice));
                    }
                }

                const lastMonth = label.length && label[label.length - 1];
                const pointStyleForSold = new Array(dataset.length);
                const newSoldDataSet = new Array(dataset.length);
                let moneyIcon = new Image();
                moneyIcon.src = `${this.glb.cdnUrl}images/desktop/icon-last-sold.svg`;
                for (let i = 0; i < label.length; i++) {
                    const soldPrice = this.priceHistoryData[label[i]];
                    if (soldPrice && soldPrice > 0) {
                        dataset[i] = soldPrice;
                        newSoldDataSet[i] = soldPrice;
                        pointStyleForSold[i] = moneyIcon;
                    }
                }

                const firstPrice = dataset.length && dataset[0];
                const lastPrice = dataset.length && dataset[dataset.length - 1];
                const monthCount = dataset.length;
                const yearCount = monthCount / 12;
                const yearMinRate = 0.02;
                let yearRate = 0;
                if (firstPrice) {
                    yearRate = (lastPrice - firstPrice) / firstPrice / yearCount;
                }
                //------- trick code if price increase rate can't be samller than 0.02
                if (yearRate < yearMinRate) {
                    yearRate = yearMinRate;
                }
                //------- tip: the real data should be yearRate
                this.forecastPriceRate = Math.floor(yearRate * 100);
                this.forecastPriceIncrease = this.forecastPriceRate > 0;
                const monthRate = yearRate / 12;
                for (let j = 2; j < maxItem.length; j++) {
                    const tmpDate = new Date(`01 ${lastMonth}`);
                    tmpDate.setMonth(tmpDate.getMonth() + j);
                    const month = tmpDate.getMonth() + 1;
                    const year = tmpDate.getFullYear();
                    if (j <= 12) {
                        label1.push(`${months[month - 1]} ${year}`);
                        dataset1.push(Math.floor(estPrice * (1 + monthRate * j)));
                    }
                }
                if (dataset.length > 1) {
                    this.lastMonthPrice = dataset[dataset.length - 1];
                }
                const emptyCount = dataset.length;
                dataset1 = new Array(emptyCount).concat(dataset1);
                const dataset2 = new Array(emptyCount);
                const pointStyle = new Array(emptyCount);
                dataset2.push(this.dpp.price);
                pointStyle.push(currentIcon);
                dataset.push(estPrice);
                label.push(label1[0]);
                dataset1 = dataset1.slice(0, emptyCount + 1);
                const buffer = 0.01;
                const max = Math.max(Math.max.apply(this, dataset), this.dpp.price);
                const min = Math.min(Math.min.apply(this, dataset), this.dpp.price);

                const yAxisController = [
                    {
                        display: true,
                        ticks: {
                            // beginAtZero: true,
                            maxTicksLimit: 6,
                            userCallback: function (value) {
                                return '$' + format.friendlyPrice(value);
                            },
                            suggestedMin: min * (1 - buffer),
                            suggestedMax: max * (1 + buffer * 4),
                        },
                        gridLines: {
                            display: true,
                            color: 'rgba(0, 0, 0, 0.1)',
                        },
                        position: 'right',
                    },
                ];
                //this.forecastLabel = label[label.length - 1];
                this.forecastPrice = dataset1[dataset1.length - 1];
                const annotations = [
                    {
                        backgroundColor: 'rgba(128, 128, 128, 0.1)',
                        drawTime: 'beforeDatasetsDraw',
                        type: 'box',
                        xMax: label1[label1.length - 1],
                        xMin: 'current',
                        xScaleID: 'x-axis-0',
                        yScaleID: 'y-axis-0',
                        mode: 'vertical',
                    },
                ];
                const lineColor = '#212121';
                const moreDataSets = [];
                this.dpp.houseRealStatus === 'ACTIVE' &&
                    moreDataSets.push({
                        label: 'Listed For', // List Price Name the series
                        data: dataset2, // Specify the data values array
                        fill: false,
                        borderColor: lineColor, // Add custom color border (Line)
                        backgroundColor: lineColor, // Add custom color background (Points and Fill)
                        pointStyle: pointStyle,
                        displayColors: false,
                        pointHitRadius: 200,
                        order: 1,
                    });
                return {
                    type: 'line',
                    data: {
                        labels: label,
                        datasets: [
                            {
                                label: '', // Name the series
                                data: dataset, // Specify the data values array
                                fill: false,
                                borderColor: lineColor, // Add custom color border (Line)
                                pointRadius: 0,
                                backgroundColor: lineColor, // Add custom color background (Points and Fill)
                                borderWidth: 2, // Specify bar border width
                                displayColors: false,
                                pointHitRadius: 200,
                                order: 2,
                                lineTension: 0,
                            },
                            {
                                label: 'Sold For', // Name the series
                                data: newSoldDataSet, // Specify the data values array

                                borderColor: lineColor, // Add custom color border (Line)
                                pointRadius: 0,
                                backgroundColor: lineColor, // Add custom color background (Points and Fill)
                                borderWidth: 2, // Specify bar border width
                                pointStyle: pointStyleForSold,
                                displayColors: true,
                                pointHitRadius: 200,
                                order: 0,
                                lineTension: 0,
                            },
                            ...moreDataSets,
                        ],
                    },
                    options: {
                        interaction: {
                            intersect: false,
                            mode: 'nearest',
                        },
                        hover: {
                            animationDuration: 5,
                            mode: 'nearest',
                            intersect: false,
                        },
                        elements: {
                            point: {
                                hoverRadius: 3.5,
                            },
                        },
                        legend: {
                            display: false,
                        },
                        annotation: {
                            annotations: annotations,
                        },
                        responsive: true, // Instruct chart js to respond nicely.
                        maintainAspectRatio: false,
                        // Add to prevent default behaviour of full-width/height
                        scales: {
                            yAxes: yAxisController,
                            xAxes: [
                                {
                                    display: true,
                                    gridLines: {
                                        display: false,
                                        color: 'rgba(0, 0, 0, .1)',
                                    },
                                    ticks: {
                                        autoSkip: false,
                                        maxRotation: 25,
                                        minRotation: 25,
                                        // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                                        callback: function (val, index) {
                                            let text = '';
                                            if (index % 12 === 0) {
                                                text = val;
                                            }
                                            return text ? text.split(' ')[1] : text;
                                        },
                                    },
                                },
                            ],
                        },
                        tooltips: {
                            enabled: true,
                            displayColors: false,
                            titleAlign: 'center',
                            bodyAlign: 'center',
                            callbacks: {
                                label: (tooltipItems, list) => {
                                    const prefix = '$';
                                    const tooltipPrefix = list.datasets && list.datasets[tooltipItems.datasetIndex] ? list.datasets[tooltipItems.datasetIndex].label + ' ' : '';
                                    if (tooltipItems.datasetIndex == 1) {
                                        delete tooltipItems.yLabel;
                                    }
                                    return tooltipItems.datasetIndex == 0 && (this.priceHistoryData[tooltipItems.label])
                                        ? ''
                                        : `${tooltipPrefix}${prefix}${format.formatNumberByComma(tooltipItems.value)}`;
                                },
                            },
                        },
                    },
                    plugins: [
                        {
                            afterDraw: (chart) => {
                                if (chart.tooltip?._active?.length) {
                                    const x = chart.tooltip._active[0]._model.x;
                                    const yAxis = chart.scales['y-axis-0'];
                                    const ctx = chart.ctx;
                                    ctx.save();
                                    ctx.beginPath();
                                    ctx.moveTo(x, yAxis.top);
                                    ctx.lineTo(x, yAxis.bottom);
                                    ctx.lineWidth = 1;
                                    ctx.strokeStyle = '#000000';
                                    ctx.stroke();
                                    ctx.restore();
                                }
                            },
                        },
                    ],
                };
            }
            return null;
        },
    },
    methods: {
        ...mapActions('dpp', ['fetchMarketChartData']),
        updateForecast(data) {
            this.dpp.forecast = data;
        },
        fetchData() {
            if (!this.isMarket5YLoaded && !this.getMarket5Y) {
                this.fetchMarketChartData({
                    cityId: this.dpp.geo.cityId,
                    countyId: this.dpp.geo.countyId,
                    isFiveYear: true,
                    neighborhoodId: this.dpp.geo.neighborhoodId,
                    zipcode: this.dpp.geo.zipcode,
                });
            }
        },
    },
    mounted() {
        this.fetchData();
    },
};
